// // // src/OTPAuthentication.js
// /* global recaptchaVerifier */

// // import { PhoneAuthCredential, PhoneAuthProvider, signInWithCredential } from 'firebase/auth';
// import { RecaptchaVerifier,signInWithPhoneNumber } from "firebase/auth";
// import React, { useState, useRef ,useEffect, } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
// import { useDispatch } from "react-redux";
// import {loginSuccess} from '../../redux/auth/actions';
import Logo from '../../assets/NewLogo.png';
// import { auth } from "../../auth/firebase";
// // import { auth } from './firebase';
// // import { PhoneAuthProvider, RecaptchaVerifier, signInWithCredential, signInWithPhoneNumber } from 'firebase/auth';
// // import { auth } from '../../auth/firebase';
// // import { auth, RecaptchaVerifier, signInWithPhoneNumber } from '../../auth/firebase'; // named imports


// const countryCodes = [
//   { code: '+1', name: 'USA' },
//   { code: '+91', name: 'India' },
//   { code: '+44', name: 'UK' },
//   // Add more country codes as needed
// ];

// const OTPAuthentication = () => {
//   const [phoneNumber, setPhoneNumber] = useState('');
//   const [countryCode, setCountryCode] = useState(countryCodes[0].code); // Default to the first country code
//   const [otp, setOtp] = useState('');
//   const [confirmationResult, setConfirmationResult] = useState(null);
//   const [error, setError] = useState('');
//   const [isOtpSent, setIsOtpSent] = useState(false);
//   const [showSuccessPopup, setShowSuccessPopup] = useState(false);
//   const [verificationId, setVerificationId] = useState(null);
//   const recaptchaRef = useRef(null); // Create a ref for reCAPTCHA container
//   const navigate = useNavigate();
//   const dispatch = useDispatch();

  
//   const otpInputs = useRef([]);
//   // const phoneNumber = getPhoneNumberFromUserInput();
//   // Initialize settings if undefined
//   if (!auth.settings) {
//     auth.settings = {};
//   }
//   auth.settings.appVerificationDisabledForTesting = true;
  
//   // const firebaseConfig = firebaseConfig
//   // const auth = getAuth();
//   // window.recaptchaVerifier = new RecaptchaVerifier(
//   //   'recaptcha-container', // ID of your HTML element
//   //   {
//   //     'size': 'invisible', // or 'normal' if visible
//   //     'callback': (response) => {
//   //       // This will be called when reCAPTCHA is solved
//   //     },
//   //     'expired-callback': () => {
//   //       // Called when reCAPTCHA expires
//   //     }
//   //   },
//   //   auth // pass the auth instance
//   // );

//   const submitButton = document.getElementById('submit-button');
//   // window.recaptchaVerifier = new RecaptchaVerifier(
//   //   'recaptcha-container',
//   //   {
//   //     'size': 'invisible',
//   //     'callback': (response) => {
//   //       submitButton.disabled = false;
//   //       document.getElementById('recaptcha-status').textContent = "✓ Verified";
//   //     }
//   //   },
//   //   auth
//   // );
  

//   window.recaptchaVerifier = new RecaptchaVerifier(
//     'recaptcha-container',
//     {
//       'size': 'invisible',
//       'callback': (response) => {

//         // Trigger phone auth here or enable your submit button
//         submitButton.disabled = false;
//       }
//     },
//     auth
//   );
  
//   // Then render it
//   recaptchaVerifier.render().then((widgetId) => {
//     window.recaptchaWidgetId = widgetId;
//   });
// useEffect(()=>{
//   // if (typeof auth.settings.appVerificationDisabledForTesting === 'undefined') {
//   //   console.error('Firebase auth settings not properly initialized');
//   //   return;
//   // }

  
  
// },[])

//   const handleSendOtp = async (e) => {
//      e.preventDefault();
//      setPhoneNumber(countryCode+phoneNumber);
//       console.log(phoneNumber,'user phone number >>>>')
  
//      signInWithPhoneNumber(auth, countryCode+phoneNumber, appVerifier)
//      .then((confirmationResult) => {
//        // SMS sent
//      })
//      .catch((error) => {
//        console.error(error);
//      });
//   };
//   // const code = getCodeFromUserInput();
//   const handleVerifyOtp = async (e) => {
//     e.preventDefault();
    
//     confirmationResult.confirm(otp).then((result) => {
//       // User signed in successfully.
//       const user = result.user;
//       console.log(user,"user login successfull")
//       // ...
//     }).catch((error) => {
//       // User couldn't sign in (bad verification code?)
//       // ...
//     });

//   };

//   const handleOtpChange = (e, index) => {
//     const { value } = e.target;

//     if (value.match(/^[0-9]{1}$/)) {
//       const newOtp = otp.split('');
//       newOtp[index] = value;
//       setOtp(newOtp.join(''));

//       if (index < otpInputs.current.length - 1) {
//         otpInputs.current[index + 1].focus();
//       }
//     } else if (value === '') {
//       if (index > 0) {
//         otpInputs.current[index - 1].focus();
//       }
//     }
//   };
//   const handleClose=()=>{
//     setShowSuccessPopup(false);
//     navigate("/")
//   }
//   const handleOnClick=()=>{
//     navigate("/")

// }

//   return (
    
//     <div className="flex items-center justify-center min-h-screen bg-[#6C5F5B]">
//             <div className="w-full max-w-md p-8 space-y-6 bg-[#4F4A45] rounded-lg shadow-md">
//             <div className="flex-1 flex justify-center">
//           <Link to="/" className="logoAuth"><img src={Logo} className='w-full h-full'></img></Link>
//         </div>
//             {/* <h1 className='bg-gradient-to-r from-blue-300 to-orange-300 text-transparent bg-clip-text text-3xl  font-bold font-serif'>PRAVASA</h1> */}
//             <div id="recaptcha-container"></div>

//       {!isOtpSent ? (
//         <form onSubmit={handleSendOtp} className="flex flex-col items-center">
//           <div className="flex mb-4">
//             <select
//               value={countryCode}
//               onChange={(e) => setCountryCode(e.target.value)}
//               className="border border-gray-300 rounded-l-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
//             >
//               {countryCodes.map(({ code, name }) => (
//                 <option key={code} value={code}>
//                   {name} {code}
//                 </option>
//               ))}
//             </select>
//             <input
//               type="text"
//               placeholder="Enter mobile number"
//               value={phoneNumber}
//               onChange={(e) => setPhoneNumber(e.target.value)}
//               required
//               className="border border-gray-300 rounded-r-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
//             />
//           </div>
//           <button
//             type="submit"
//             className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 transition"
//             id="submit-button" 
//           >
//             Get OTP
//           </button>
//           <button
//                 type='submit'
//                 onClick={handleOnClick}
//                 className="w-full py-2 mt-4 text-blue-600 bg-transparent hover:bg-blue-500 focus:outline-none"
//                 >
//                         Explore as guest!!
//                 </button>
//         </form>
//       ) : (
//         <form onSubmit={handleVerifyOtp} className="flex flex-col items-center">
//           <div className="flex mb-4 space-x-2">
//             {[...Array(6)].map((_, index) => (
//               <input
//                 key={index}
//                 type="text"
//                 maxLength="1"
//                 ref={(el) => (otpInputs.current[index] = el)}
//                 onChange={(e) => handleOtpChange(e, index)}
//                 className="border border-gray-300 rounded-md p-2 shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-12 h-12 text-center"
//               />
//             ))}
//           </div>
//           <button
//             type="submit"
//             className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 transition"
//           >
//             Verify OTP
//           </button>
//         </form>
//       )}

//       {error && <p className="text-red-500 mt-4">{error}</p>}

//       {showSuccessPopup && (
//         <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-75">
//           <div className="bg-white p-6 rounded-md shadow-md">
//             <h3 className="text-lg font-bold">Success!</h3>
//             <p>Your phone number has been verified successfully.</p>
//             <button
//               onClick={() => handleClose()}
//               className="mt-4 bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 transition"
//             >
//               Close
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//     </div>
//   );
// };

// export default OTPAuthentication;



///new code 



// src/components/PhoneAuth.js
import { useState, useEffect, useRef } from 'react';
import { 
  signInWithPhoneNumber,
  RecaptchaVerifier 
} from "firebase/auth";
import { auth , firebaseConfig} from '../../auth/firebase';
import AuthForm from './AuthForm';


export default function OTPAuthentication() {
  const [phone, setPhone] = useState('');
  const [otp, setOtp] = useState('');
  const [confirmationResult, setConfirmationResult] = useState(null);
  const recaptchaVerifier = useRef(null);
  const navigate = useNavigate();
  const otpInputs = useRef([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  // // 
  // function initRecaptcha() {
  //   try {
  //     const recaptchaVerifier = new RecaptchaVerifier('recaptcha-container', {
  //       'size': 'invisible',
  //       'callback': (response) => {
  //         console.log('reCAPTCHA solved', response);
  //       },
  //       'expired-callback': () => {
  //         console.log('reCAPTCHA expired');
  //       }
  //     }, auth); // Pass auth instance
      
  //     return recaptchaVerifier;
  //   } catch (error) {
  //     console.error('reCAPTCHA init failed:', error);
  //     throw error;
  //   }
  // }
  useEffect(() => {
    // Clear any existing reCAPTCHA
    if (recaptchaVerifier.current) {
      recaptchaVerifier.current.clear();
    }
    console.log('Using project ID:', firebaseConfig.projectId);

    try {
      recaptchaVerifier.current = new RecaptchaVerifier(auth, 'recaptcha-container', {
        'size': 'invisible',
        'callback': (response) => {
          console.log('reCAPTCHA solved', response);
          // Proceed with phone auth
        },
        'expired-callback': () => {
          console.log('reCAPTCHA expired');
          // Handle expiration
        }
      });
      
      // Render the reCAPTCHA widget
      recaptchaVerifier.current.render();
    } catch (error) {
      console.error('reCAPTCHA initialization failed:', error);
    }

    return () => {
      if (recaptchaVerifier.current) {
        recaptchaVerifier.current.clear();
      }
    };
  }, []);

  const sendOTP = async () => {
    try {
      const formattedPhone = `+91${phone.replace(/\D/g, '')}`;
      const confirmation = await signInWithPhoneNumber(
        auth,
        formattedPhone,
        recaptchaVerifier.current
      );
      setConfirmationResult(confirmation);
      alert('OTP sent successfully!');
    } catch (error) {
      console.error('Error sending OTP:', error);
      alert(`Error: ${error.message}`);
    }
  };

  const verifyOTP = async () => {
    // try {
    //   await confirmationResult.confirm(otp);
    //   alert('Phone number verified!');
    //   navigate("/")

    //   // User is now signed in
    // } catch (error) {
    //   console.error('Error verifying OTP:', error);
    //   alert(`Error: ${error.message}`);
    // }
  //   console.log(otp,':::::user otp::::::')
  //   window.confirmationResult.confirm(otp)
  // .then((result) => {
  //   alert('Phone number verified!');
  //   console.log(result,':::::user loggin result::::::')
  //   // User signed in successfully
  // })
  // .catch((error) => {
  //   console.error("Error verifying OTP:", error);
  // });
  try {
    // setLoading(true);
    // setError('');
    console.log("user login otp is ::::>>>",otp);
    const result = await confirmationResult.confirm(otp);
    const user = result.user;
    setMessage('OTP verified successfully!');
    console.log("User authenticated:", user);
    alert('Phone number verified!');
    navigate("/");
    // You can redirect or update app state here
  } catch (err) {
    setError('Invalid OTP. Please try again.');
    console.error("Error verifying OTP:", err);
  } finally {
    setLoading(false);
  }
  };

  const handleOnClick=()=>{
    navigate("/")

};

  const handleOtpChange = (e, index) => {
    if (e) e.preventDefault();
    const { value } = e.target;

    if (value.match(/^[0-9]{1}$/)) {
      const newOtp = otp.split('');
      newOtp[index] = value;
      const finalOTP = newOtp.join('');
      console.log(finalOTP,"is opt")
      if(finalOTP.length === 6 ){

        setOtp(finalOTP);
      }
     

      if (index < otpInputs.current.length - 1) {
        otpInputs.current[index + 1].focus();
      }
    } else if (value === '') {
      if (index > 0) {
        otpInputs.current[index - 1].focus();
      }
    }
    console.log("opt are : ", otp);
  };

  return (
    <div>
       <div id="recaptcha-container"></div>
        <div className="flex items-center justify-center min-h-screen bg-[#6C5F5B]">
           <div className="w-full max-w-md p-8 space-y-6 bg-[#4F4A45] rounded-lg shadow-md">
        <div className="flex-1 flex justify-center">
     <Link to="/" className="logoAuth"><img src={Logo} className='w-full h-full'></img></Link>
       </div>
     
      <div>
      <AuthForm isLogin={false} onSuccess={(data) => console.log('Signed up:', data)} />
      </div>
      {!confirmationResult ? (
        <div className="flex flex-col items-center">
         <div className="flex mb-4">
          <input
            type="tel"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            placeholder="Enter phone number"
             className="border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          /><br/>
          </div>
          <button onClick={sendOTP} className="bg-blue-500 text-white mx-4 px-4 py-2 rounded-md hover:bg-blue-600 transition">Send OTP</button>
          <button
                type='submit'
               onClick={handleOnClick}
               className="w-full py-2 mt-4 text-blue-600 bg-transparent hover:bg-blue-500 focus:outline-none"
             >
                     Explore as guest!!
               </button>
        </div>
      ) : (
        <>

<form onSubmit={verifyOTP} className="flex flex-col items-center">
          <div className="flex mb-4 space-x-2">
            {[...Array(6)].map((_, index) => (
              <input
                key={index}
               type="number"
                maxLength="1"
                ref={(el) => (otpInputs.current[index] = el)}
               onChange={(e) => handleOtpChange(e, index)}
               className="border border-gray-300 rounded-md p-2 shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-12 h-12 text-center"
            />
         ))}
         {/* <input
              type="text"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              placeholder="Enter OTP"
              maxLength="6"
              required
            /> */}
         </div>
         <button
          type="submit"
           className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 transition"
           disabled={!otp || loading}
         >
            
             {loading ? 'Verifying...' : 'Verify OTP'}
         </button>
       </form>

          {/* <input
            type="text"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            placeholder="Enter OTP"
          />
          <button onClick={verifyOTP}>Verify OTP</button> */}
        </>
      )}
    </div>
    </div>
    {error && <div className="error">{error}</div>}
      {message && <div className="success">{message}</div>}
    </div>
  );
}